import {Component} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import {UserService} from "../../../../../../@shared/services/user.service";
import {Observable} from "rxjs";
import {IFreeCase} from "../../../services/interfaces/free-cases.interface";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";


@Component({
  selector: 'app-add-free-user-cases',
  templateUrl: './add-free-user-cases.component.html',
  styleUrls: ['./add-free-user-cases.component.scss']
})
export class AddFreeUserCasesComponent {

  public selectedFreeCase: IFreeCase | null = null;
  public allFreeCases$: Observable<IFreeCase[]> = this.userService.getAllFreeCases();
  public addFeeCaseForm: FormGroup = this.fb.group({
    count: [null, [Validators.required, Validators.min(0)]],
    freeCaseId: [null, [Validators.required]]
  })


  constructor(public dialogRef: MatDialogRef<AddFreeUserCasesComponent>,
              private userService: UserService,
              private fb: FormBuilder) {
  }

  public addFreeUserCase(): void {
    this.userService.addUserFreeCase(this.addFeeCaseForm.value).subscribe(
      () => this.dialogRef.close(true));
  }

  public setSelectedCase(item: IFreeCase): void {
    this.selectedFreeCase = item;
  }

  public close(): void {
    this.dialogRef.close();
  }

}
